module.exports = __webpack_public_path__ + "static/media/ogads.e0e7bc3c.png";